import { useState, useEffect } from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { SIDANG_TYPE_WITH_JENJANG } from "../../utils/constants/SidangType.constants";
import MaterialTable from "material-table";
import JadwalSidangService from "../../services/Integration/jadwal-sidang/JadwalSidangService";
import PlaceDateTime from "../../components/common/PlaceDateTime/PlaceDateTime";
import TermService from "../../services/Integration/term/TermService";
import Auth from "../../services/Auth/Auth";

let currentTerm = {
  id_term: null,
  periode: null,
  semester: null,
};

const AnonHome = ({ isDosen }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [jadwalSidangs, setJadwalSidangs] = useState({
    term: "",
    jadwal_sidang: [],
  });
  const [terms, setTerms] = useState([]);
  const [termSelected, setTermSelected] = useState(currentTerm);

  
  const getJadwalSidangs = async (termSelectedId) => {
    let dosenId = null;
    if (isDosen) {
      dosenId = Auth.getCurrentUser().id;
    }
    await JadwalSidangService.getJadwalSidangsPublic(termSelectedId || termSelected.id_term, dosenId)
      .then((response) => {
        if (response.status === 200) {
          setJadwalSidangs(response.data);
        } else {
          console.log(response);
        }
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    async function getTermsListAndJadwalSidangs() {
      await TermService.getTermList()
      .then((response) => {
        if (response.status === 200) {
          setTerms(response.data);
          const latestTerm = response.data[0];
          setCurrentTermSelected(latestTerm);
          getJadwalSidangs(latestTerm.id_term);
        }
      })
      .catch((response) => console.log(response));
      setIsLoading(false);
    }
    
    getTermsListAndJadwalSidangs()
  }, []);

  const refreshData = async () => {
    setIsLoading(true);
    await getJadwalSidangs(termSelected.id_term);
    setIsLoading(false);
  };

  function setCurrentTermSelected(term) {
    currentTerm = { ...term };
    setTermSelected(currentTerm);
  }

  return (
    <div>
      {isLoading ? (
        <div className="flex justify-center">
          <CircularProgress />
        </div>
      ) : (
        <>
          {!terms?.length ? (
            <h2 className="text-center">
              Tidak ada pilihan semester, silakan buat Semester terlebih dahulu
            </h2>
          ) : (
            <>
              <Autocomplete
                sx={{ width: 250, paddingY: 2 }}
                size="small"
                id="semester"
                value={termSelected}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setCurrentTermSelected(newValue);
                    getJadwalSidangs(newValue.id_term)
                  };
                }}
                options={terms}
                noOptionsText={"Semester tidak ditemukan"}
                getOptionLabel={(option) =>
                  option.semester && option.periode
                    ? option.semester + " " + option.periode
                    : ""
                }
                isOptionEqualToValue={(option, value) =>
                  option.id_term === value.id_term
                }
                renderOption={(props, option) => (
                  <span {...props}>
                    {option.semester} {option.periode}
                  </span>
                )}
                defaultValue={termSelected}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Semester"
                    required={true}
                    variant="filled"
                    size="medium"
                  />
                )}
              />
              <MaterialTable
                style={{ fontSize: 14 }}
                isLoading={isLoading}
                title={
                  <span className="text-lg">
                    Daftar Sidang {jadwalSidangs.term}
                  </span>
                }
                data={jadwalSidangs.jadwal_sidang}
                columns={[
                  {
                    title: "Jenis MK Spesial",
                    field: "jenis_sidang",
                    lookup: SIDANG_TYPE_WITH_JENJANG,
                  },

                  { title: "Judul", field: "judul" },

                  {
                    title: "Mahasiswa",
                    field: "mahasiswa",
                    grouping: false,
                    render: (rowData) => (
                      <ul className="ml-4 list-disc">
                        {rowData.mahasiswa.map((namaMahasiswa, index) => (
                          <li key={index}>{namaMahasiswa}</li>
                        ))}
                      </ul>
                    ),
                    customFilterAndSearch: (filter, rowData) =>
                      rowData.mahasiswa.some((namaMahasiswa) => {
                        let mahasiswaName = namaMahasiswa.toLowerCase();
                        let filterLowered = filter.toLowerCase();
                        return mahasiswaName.includes(filterLowered);
                      }),
                  },

                  {
                    title: "Pembimbing",
                    field: "pembimbing",
                    grouping: false,
                    render: (rowData) => (
                      <div>
                        {rowData.pembimbing.length === 0 ? (
                          <p>-</p>
                        ) : (
                          <ul className="ml-4 list-disc">
                            {rowData.pembimbing.map((dosbing, index) => (
                              <li key={index}>{dosbing}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ),
                    customFilterAndSearch: (filter, rowData) => {
                      const filterLowered = filter.toLowerCase();
                      return rowData.pembimbing.some((dosbing) =>
                        dosbing.toLowerCase().includes(filterLowered)
                      );
                    },
                  },

                  {
                    title: "Penguji",
                    field: "penguji",
                    grouping: false,
                    render: (rowData) => (
                      <div>
                        {rowData.penguji.length === 0 ? (
                          <p>-</p>
                        ) : (
                          <ul className="ml-4 list-disc">
                            {rowData.penguji.map((dosji, index) => (
                              <li key={index}>{dosji}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ),
                    customFilterAndSearch: (filter, rowData) => {
                      const filterLowered = filter.toLowerCase();
                      return rowData.penguji.some((dosji) =>
                        dosji.toLowerCase().includes(filterLowered)
                      );
                    },
                  },

                  {
                    title: "Jadwal Sidang",
                    filtering: false,
                    grouping: false,
                    defaultSort: "asc",
                    render: (rowData) => (
                      <div>
                        <PlaceDateTime
                          isOldVersion={false}
                          isOnline={rowData.is_sidang_online}
                          place={rowData.ruangan}
                          date={rowData.tanggal}
                          startTime={rowData.jam_mulai}
                          endTime={rowData.jam_selesai}
                        />
                      </div>
                    ),
                    customSort: (data1, data2) =>
                      new Date(`${data2.tanggal}T${data2.jam_mulai}Z`) -
                      new Date(`${data1.tanggal}T${data1.jam_mulai}Z`),
                  },
                ]}
                actions={[
                  {
                    icon: "refresh",
                    tooltip: "Refresh Data",
                    isFreeAction: true,
                    onClick: () => {
                      refreshData();
                    },
                  },
                ]}
                options={{
                  actionsColumnIndex: -1,
                  sorting: true,
                  search: true,
                  filtering: true,
                  grouping: false,
                  pageSize: 10,
                }}
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default AnonHome;
